import { useRef, useState } from "react";
import ReactDOM from "react-dom";

import classes from './BodySimpleModal.module.css'

export default function BodySimpleModalHTML({isDisabled, messages, normalEvent, htmlText }) {
    const messageRef = useRef(null);
    const [showInactveReason, setShowInactiveReason] = useState(false);
    const [coordinates, setCoordinates] = useState({
        top: null,
        left: null,
    });
    function mouseEnterHandler() {
        setShowInactiveReason(true);
        if (messageRef && messageRef.current) {
            let left = messageRef.current.getBoundingClientRect().left;
            let right = messageRef.current.getBoundingClientRect().right;
            let top = messageRef.current.getBoundingClientRect().top;
            setCoordinates({
                top: top,
                left: left + (right - left) / 2,
            });
        }
    }
    function mouseLeaveHandler() {
        setShowInactiveReason(false);
    }

    return (
        <>
            {isDisabled && messages && messages.length > 0 ? (
                <div className={classes.fixed_message_container} ref={messageRef} onMouseEnter={mouseEnterHandler} onMouseLeave={mouseLeaveHandler} >
                    {showInactveReason && (
                        <>
                            {ReactDOM.createPortal(
                                <div
                                    className={classes.fixed_message}
                                    style={{
                                        top: coordinates.top,
                                        left: coordinates.left,
                                    }}
                                >
                                    <div dangerouslySetInnerHTML={{__html: messages}} />
                                </div>,
                                document.getElementById("overlay-root")
                            )}
                        </>
                    )}
                </div>
            ) : (
                ""
            )}
            {normalEvent && messages && messages.length > 0 ? (
                <div className={classes.fixed_message_container_normal} ref={messageRef} onMouseEnter={mouseEnterHandler} onMouseLeave={mouseLeaveHandler} >
                    {showInactveReason && (
                        <>
                            {ReactDOM.createPortal(
                                <div className={classes.fixed_message} style={{
                                        top: coordinates.top,
                                        left: coordinates.left,
                                    }}
                                >
                                    <div dangerouslySetInnerHTML={{__html: messages}} />
                                </div>,
                                document.getElementById("overlay-root")
                            )}
                        </>
                    )}
                </div>
            ) : (
                ""
            )}
        </>
    );
}
